import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SettingDialog from '@/views/dashboard/setting/version-update/_components/cascade-setting/setting-dialog.vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'cascade-setting',
  setup(__props) {

const settingDialogVisible = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (settingDialogVisible.value = true)),
      class: "link"
    }, _toDisplayString(_ctx.$t('cascadeUpdateSetting.dialogTitle')), 1),
    _createVNode(SettingDialog, {
      modelValue: settingDialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((settingDialogVisible).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})